import { KeyValue } from "@/main/models/common";
import { DistributionRegionTypes, DistributionRegionActionTypes } from "./distributionRegionTypes";
import { DistributionRegionFilterRequest } from "@/main/models/request";

export function getDistributionRegion(request: DistributionRegionFilterRequest): DistributionRegionActionTypes {
	return {
		type: DistributionRegionTypes.GET_DISTRIBUTION_REGION,
		payload: { request },
	};
}

export function saveDistributionRegion(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): DistributionRegionActionTypes {
	return {
		type: DistributionRegionTypes.SAVE_DISTRIBUTION_REGION,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerDistributionRegion(): DistributionRegionActionTypes {
	return {
		type: DistributionRegionTypes.RESET_REDUCER_DISTRIBUTION_REGION,
	};
}
